// import React, { useContext, useEffect, useState } from "react";
// import css from "../css/Refer.module.css";
// import { Link } from "react-router-dom";
// import axios from "axios";
// import Swal from "sweetalert2";

// import { BsWhatsapp } from "react-icons/bs";
// import { BsChevronDown } from 'react-icons/bs';
// import { BsPerson } from 'react-icons/bs';
// import { BsCash } from 'react-icons/bs';

// import { AiOutlineInstagram, AiFillFacebook } from "react-icons/ai";
// import CopyToClipboard from "react-copy-to-clipboard";
// import { FaTelegramPlane } from "react-icons/fa";
// import { FiCopy } from "react-icons/fi";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);
//   const theme = localStorage.getItem('theme')


//   const addsetting = localStorage.getItem("sitSetting");
//   const addCaseSetting = JSON.parse(addsetting);

//   const [cardData, setGame] = useState([]);

//   const copyCode = (e) => {
//     navigator.clipboard.writeText(user.referral_code);

//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referral Code Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   const copyLink = (e) => {
//     Swal.fire({
//       position: "center",
//       icon: "success",
//       type: "success",
//       title: "Referal Link Copied",
//       showConfirmButton: false,
//       timer: 1200,
//     });
//   };

//   if (user === undefined) {
//     return null;
//   }

//   const referralText = `Hi Friends, Play hkstar.in Ludo and earn 10000 daily. Download Indian App hkstar.in
//   बम्मफर  धमाका ऑफर  💸💸💸 💥💥💥💥💥💥
//    दोस्तो आ गया है भारत का पहला ऐसा गेमिंग प्लेटफॉर्म जहा आपको win पर रैफर कमीशन 4% दिया जाएगा अगर आपका दोस्त आपके रेफर से गेम खेलता तो आपको 4% commission दिया जायेगा
  
//     NK ADDA पर लूडो खेल कर या दोस्तों को शेयर कर के पैसा जीतो और तुरंत अपने Bank या UPI में ट्रांसफर कर सकते हो 
//     100% भरोसेमंद प्लेटफार्म । 24 hours support https://hkstar.in/login/${user.referral_code}
    
//     Your ReferralCode is -${user.referral_code}.`


//   // language 


//   const translations = {
//     hi: {
//       referral: 'आपकी रेफरल कमाई',
//       referPerson: 'आमंत्रित किये दोस्त | ',
//       referEarn: 'रेफरल कमाई  ',
//       referCode: 'रेफरल कोड ',
//     },
//     en: {
//       referral: 'Your Referral Earnings',
//       referPerson: 'Referred Players',
//       referEarn: 'Referral Earning',
//       referCode: 'Referral Code',
//     },
//   };

//   // change theme 

//   const styles = {
//     backgroundColor: theme === 'light' ? '#d3e3fd' : 'black',
//     color: theme === 'light' ? 'black' : 'black',
//   };
//   const styles1 = {
//     color: theme === 'light' ? 'black' : 'white',
//   };


//   return (
//     <>
//       {/* <Header user={user} /> */}
//       <div style={styles}>
//         <div
//           className="leftContainer mt-5 pt-5"
//           style={{ ...styles, height: "100%" }}
//         >
//           <section className="referUnique">

//             {/* NEW STYLE INTRO CARD */}
//             <div className="introRibbonCard">
//               <div className="ribbonBar"></div>

//               <div className="ribbonContent">
//                 <img src="/images/refer.png" className="refer_icon" />
//                 <div>
//                   <h3>Refer & Earn</h3>
//                   <p>You can earn more more real money doing refer to your friends</p>
//                 </div>
//               </div>
//             </div>

//             {/* REFERRAL CODE CARD */}
//             <div className="codeLayerCard">
//               <label>Your Referral Code</label>

//               <div className="codeRow">
//                 <strong>{user.referral_code}</strong>

//                 <button className="copySmall" onClick={(e) => copyCode(e)}>
//                   Copy
//                 </button>
//               </div>
//             </div>
//             <div className="whatsapp_share_btn">
//               <a
//                 href={`whatsapp://send?text=Play%20On%20hkstar.in%20%0A%E0%A4%B2%E0%A5%82%E0%A4%A1%E0%A5%8B%20%E0%A4%96%E0%A5%87%E0%A4%B2%20%E0%A4%95%E0%A4%B0%20%E0%A4%AF%E0%A4%BE%20%E0%A4%A6%E0%A5%8B%E0%A4%B8%E0%A5%8D%E0%A4%A4%E0%A5%8B%E0%A4%82%20%E0%A4%95%E0%A5%8B%20%E0%A4%B6%E0%A5%87%E0%A4%AF%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%95%E0%A5%87%20%E0%A4%AA%E0%A5%88%E0%A4%B8%E0%A4%BE%20%E0%A4%9C%E0%A5%80%E0%A4%A4%E0%A5%8B%20%E0%A4%94%E0%A4%B0%20%E0%A4%A4%E0%A5%81%E0%A4%B0%E0%A4%82%E0%A4%A4%20%E0%A4%85%E0%A4%AA%E0%A4%A8%E0%A5%87%20Bank%20%E0%A4%AF%E0%A4%BE%20UPI%20%E0%A4%AE%E0%A5%87%E0%A4%82%20%E0%A4%9F%E0%A5%8D%E0%A4%B0%E0%A4%BE%E0%A4%82%E0%A4%B8%E0%A4%AB%E0%A4%B0%20%E0%A4%95%E0%A4%B0%20%E0%A4%B8%E0%A4%95%E0%A4%A4%E0%A5%87%20%E0%A4%B9%E0%A5%88%E0%A5%A4%0A%0AAuto%20Deposit%20%26%20Auto%20Withdrawal%0A%0AInstant%20Withdrawal%20Via%20UPI%2FBank%2FWallet%20%0A%0ACommission%205%25%20Only%0AReferral%20commission%203%25%0A%0A100%25%20%E0%A4%AD%E0%A4%B0%E0%A5%8B%E0%A4%B8%E0%A5%87%E0%A4%AE%E0%A4%82%E0%A4%A6%20%E0%A4%AA%E0%A5%8D%E0%A4%B0%E0%A5%87%E0%A4%9F%E0%A4%AB%E0%A4%BE%E0%A4%B0%E0%A5%8D%E0%A4%AE%20%0A%0A24x7%20Live%20Chat%20%26%20Call%20Support%0A%0Ahttps%3A%2F%2Fhkstar.inludo.com%2Flogin%2F${user.referral_code}`}



//               >
//                 <BsWhatsapp className="icons" />
//                 <span class="ml-2">Whatsapp</span>
//               </a>
//             </div>

//             {/* STATS */}
//             <div className="statsFlex">

//               <div className="statLayerCard">
//                 <div>
//                   <h4>{user.referral_user?.length}</h4>
//                   <p>People Referred</p>
//                 </div>
//                 <img src="/images/trophy.png" className="stat_icon" />
//               </div>

//               <div className="statLayerCard">
//                 <div>
//                   <h4>₹{user.referral_earning}</h4>
//                   <p>Total Earned</p>
//                 </div>
//                 <img src="/images/monney.png" className="stat_icon" />
//               </div>

//             </div>

//           </section>


//         </div>
//       </div>
//     </>
//   );
// };

// export default Refer;


// import React, { useContext } from "react";
// import Swal from "sweetalert2";
// import { BsWhatsapp } from "react-icons/bs";
// import { FiCopy } from "react-icons/fi";
// import { LanguageContext } from "../Components/LanguageContext";
// // import "./ReferUI.css"; 

// const Refer = ({ user }) => {
//   const { language } = useContext(LanguageContext);

//   if (!user) return null;

//   const copyCode = () => {
//     navigator.clipboard.writeText(user.referral_code);
//     Swal.fire({
//       icon: "success",
//       title: "Referral Code Copied",
//       showConfirmButton: false,
//       timer: 1000,
//     });
//   };

//   // const shareText = `Play HkStar and earn daily! Join using my code: ${user.referral_code} \nLink: https://hkstar.in/login/${user.referral_code}`;
// const shareText = `🔥 Hello Dost 👋

// Apni Site HkStar par Game Khelo aur Daily Paisa Jeeto 💸

// 🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

// 🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

// 👉 Join Now:
// https://hkstar.in/login/${user.referral_code}

// 🎯 Referral Code: ${user.referral_code}`;
//   return (
//     <div className="refer-page-wrapper leftContainer mt-5 pt-5">
//       <div className="refer-main-container">
        
//         {/* Title Section */}
//         <div className="refer-title-section">
//           <h1>Invite & Earn</h1>
//           <p>Share your code and get 3% of your friend's winnings!</p>
//         </div>

//         {/* Unique Referral Code Card */}
//         <div className="referral-code-card">
//           <label>YOUR UNIQUE REFERRAL CODE</label>
//           <div className="code-row">
//             <div className="dashed-code-box">
//               {user.referral_code}
//             </div>
//             <button className="copy-btn-blue" onClick={copyCode}>
//               <FiCopy /> Copy
//             </button>
//           </div>
//         </div>

//         {/* WhatsApp Button */}
//         <a 
//           href={`whatsapp://send?text=${encodeURIComponent(shareText)}`} 
//           className="whatsapp-btn-full"
//         >
//           <BsWhatsapp className="wa-icon" /> WhatsApp
//         </a>

//         {/* Stats Divider */}
//         <div className="stats-divider">
//           <div className="divider-line"></div>
//           <span>YOUR STATS</span>
//           <div className="divider-line"></div>
//         </div>

//         {/* Stats Grid */}
//         <div className="refer-stats-grid">
//           <div className="stat-box purple-box">
//             <div className="stat-content">
//               <h2>{user.referral_user?.length || 0}</h2>
//               <p>Total Players</p>
//             </div>
//             <img src="/images/trophy-bg.png" alt="" className="box-bg-icon" />
//           </div>

//           <div className="stat-box orange-box">
//             <div className="stat-content">
//               <h2>₹{user.referral_earning || 0}</h2>
//               <p>Total Earnings</p>
//             </div>
//             <img src="/images/money-bag.png" alt="" className="box-bg-icon" />
//           </div>
//         </div>

//         {/* How It Works */}
//         <div className="how-it-works-card mb-5">
//           <h3><span className="info-icon">🛈</span> How It Works</h3>
          
//           <div className="step-row">
//             <div className="step-number">01</div>
//             <p>You can refer and <strong>Earn 3%</strong> of your referral winning, every time.</p>
//           </div>

//           <div className="step-row">
//             <div className="step-number">02</div>
//             <p>If your player wins <strong>₹10,000</strong>, you instantly get <strong>₹300</strong> in your wallet.</p>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default Refer;


import React, { useContext } from "react";
import Swal from "sweetalert2";
import { BsWhatsapp } from "react-icons/bs";
import { FiCopy } from "react-icons/fi";
import { LanguageContext } from "../Components/LanguageContext";

const Refer = ({ user }) => {
  const { language } = useContext(LanguageContext);

  if (!user) return null;

  const copyCode = () => {
    navigator.clipboard.writeText(user.referral_code);
    Swal.fire({
      icon: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1000,
    });
  };

  const shareText = `🔥 Hello Dost 👋

Apni Site HkStar par Game Khelo aur Daily Paisa Jeeto 💸

🎁 Referral Code se Join karo aur pao 3% Referral Commission ka fayda.

🕹️ Fast Deposit • Fast Withdraw • Real Cash Games

👉 Join Now:
https://hkstar.in/login/${user.referral_code}

🎯 Referral Code: ${user.referral_code}`;

  const styles = {
    wrapper: {
      maxWidth: "850px",
      margin: "0 auto",
      padding: "20px",
    },

    heroCard: {
      background:
        "linear-gradient(135deg,#4f46e5 0%,#7c3aed 50%,#ec4899 100%)",
      borderRadius: "28px",
      padding: "35px 25px",
      textAlign: "center",
      color: "#fff",
      marginBottom: "25px",
      boxShadow: "0 15px 40px rgba(79,70,229,.25)",
    },

    heroTitle: {
      fontSize: "clamp(28px,5vw,42px)",
      fontWeight: "800",
      margin: 0,
    },

    heroText: {
      marginTop: "10px",
      fontSize: "15px",
      opacity: 0.95,
    },

    referralCard: {
      background: "#fff",
      borderRadius: "24px",
      padding: "25px",
      marginBottom: "20px",
      boxShadow: "0 10px 35px rgba(0,0,0,.08)",
      border: "1px solid #f2f2f2",
    },

    label: {
      display: "block",
      textAlign: "center",
      color: "#777",
      fontWeight: "700",
      marginBottom: "18px",
      letterSpacing: "1px",
    },

    codeRow: {
      display: "flex",
      gap: "12px",
      flexWrap: "wrap",
    },

    codeBox: {
      flex: 1,
      minWidth: "220px",
      border: "2px dashed #6366f1",
      background: "#f8fafc",
      borderRadius: "18px",
      padding: "18px",
      textAlign: "center",
      fontWeight: "800",
      fontSize: "24px",
      color: "#4f46e5",
      letterSpacing: "2px",
    },

    copyBtn: {
      border: "none",
      background: "#4f46e5",
      color: "#fff",
      borderRadius: "16px",
      padding: "0 22px",
      cursor: "pointer",
      fontWeight: "700",
      display: "flex",
      alignItems: "center",
      gap: "8px",
      minHeight: "60px",
    },

    whatsappBtn: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      textDecoration: "none",
      background:
        "linear-gradient(135deg,#25D366 0%,#128C7E 100%)",
      color: "#fff",
      borderRadius: "18px",
      padding: "18px",
      fontWeight: "700",
      fontSize: "18px",
      marginBottom: "25px",
      boxShadow: "0 10px 25px rgba(37,211,102,.25)",
    },

    divider: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      marginBottom: "20px",
    },

    line: {
      flex: 1,
      height: "1px",
      background: "#ddd",
    },

    dividerText: {
      fontWeight: "700",
      color: "#666",
    },

    statsGrid: {
      display: "grid",
      gridTemplateColumns:
        "repeat(auto-fit,minmax(250px,1fr))",
      gap: "15px",
      marginBottom: "25px",
    },

    playerCard: {
      background:
        "linear-gradient(135deg,#7c3aed,#a855f7)",
      color: "#fff",
      borderRadius: "22px",
      padding: "25px",
      position: "relative",
      overflow: "hidden",
    },

    earningCard: {
      background:
        "linear-gradient(135deg,#f97316,#fb923c)",
      color: "#fff",
      borderRadius: "22px",
      padding: "25px",
      position: "relative",
      overflow: "hidden",
    },

    statNumber: {
      fontSize: "36px",
      fontWeight: "800",
      marginBottom: "5px",
    },

    statText: {
      fontSize: "15px",
      opacity: 0.95,
    },

    workCard: {
      background: "#fff",
      borderRadius: "24px",
      padding: "25px",
      boxShadow: "0 10px 35px rgba(0,0,0,.08)",
      marginBottom: "40px",
      border:"2px dashed #2b2525"
    },

    workTitle: {
      marginBottom: "25px",
      fontSize: "22px",
      fontWeight: "800",
      color: "#222",
    },

    stepRow: {
      display: "flex",
      gap: "15px",
      marginBottom: "18px",
      alignItems: "flex-start",
    },

    stepNumber: {
      minWidth: "45px",
      height: "45px",
      borderRadius: "50%",
      background:
        "linear-gradient(135deg,#4f46e5,#7c3aed)",
      color: "#fff",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "800",
    },

    stepText: {
      flex: 1,
      lineHeight: "1.6",
      color: "#555",
    },
  };

  return (
    <div className="refer-page-wrapper leftContainer mt-5 pt-5">
      <div style={styles.wrapper}>
        <div style={styles.heroCard}>
          <h1 style={styles.heroTitle}>🎉 Invite & Earn</h1>
          <p style={styles.heroText}>
            Share your code and get 3% of your friend's winnings!
          </p>
        </div>

        <div style={styles.referralCard}>
          <label style={styles.label}>
            YOUR UNIQUE REFERRAL CODE
          </label>

          <div style={styles.codeRow}>
            <div style={styles.codeBox}>
              {user.referral_code}
            </div>

            <button
              style={styles.copyBtn}
              onClick={copyCode}
            >
              <FiCopy />
              Copy
            </button>
          </div>
        </div>

        <a
          href={`whatsapp://send?text=${encodeURIComponent(
            shareText
          )}`}
          style={styles.whatsappBtn}
        >
          <BsWhatsapp size={22} />
          Share on WhatsApp
        </a>

        <div style={styles.divider}>
          <div style={styles.line}></div>
          <span style={styles.dividerText}>
            YOUR STATS
          </span>
          <div style={styles.line}></div>
        </div>

        <div style={styles.statsGrid}>
          <div style={styles.playerCard}>
            <div style={styles.statNumber}>
              {user.referral_user?.length || 0}
            </div>
            <div style={styles.statText}>
              Total Players
            </div>
          </div>

          <div style={styles.earningCard}>
            <div style={styles.statNumber}>
              ₹{user.referral_earning || 0}
            </div>
            <div style={styles.statText}>
              Total Earnings
            </div>
          </div>
        </div>

        <div style={styles.workCard}>
          <h3 style={styles.workTitle}>
            🛈 How It Works
          </h3>

          <div style={styles.stepRow}>
            <div style={styles.stepNumber}>01</div>

            <div style={styles.stepText}>
              You can refer and <strong>Earn 3%</strong> of
              your referral winning, every time.
            </div>
          </div>

          <div style={styles.stepRow}>
            <div style={styles.stepNumber}>02</div>

            <div style={styles.stepText}>
              If your player wins <strong>₹10,000</strong>,
              you instantly get <strong>₹300</strong> in
              your wallet.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refer;
